<div class="Main">
  <!-- Note -->
  <div class="col-12 mt-2">
    <p class="text-danger" *ngIf="!canAddTask">
      <!-- Note: Currently, data processing is in progress. users are unable to add or update data. Please try again after some time. -->
       {{dataProcessingNote}}
    </p>
  </div>
  <div class="task-container billable-tasks">
    <div class="row">
      <div class="col-md-6" style="display: flex;">
        <!-- <i class="pi pi-money-bill"></i> -->
        <h4>Billable Tasks</h4>
        <span class="currentweek">{{ formatDateNew(this.Startweek) }} - {{ formatDateNew(this.Endweek) }}</span>
      </div>
      <div class="col-md-6 d-flex justify-content-end align-items-center">
      
        <div style="display: flex; flex-direction: column; margin-right: 16px; padding: 4px 12px;
                      border: 1px solid #dee2e6; border-radius: 6px; background: #f8f9fa;">
          <span style="font-size: 11px; color: #6c757d;">DB Server Time</span>
          <span style="font-size: 13px; font-weight: 500;">{{ serverTime }}</span>
        </div>

        <p-button label="Add Billable Task" [disabled]="!canAddTask" (click)="addNewProject()"></p-button>
        <!--  <button pButton type="button" icon="pi pi-angle-left" label="Previous Week" class="btn-primary" (click)="navigatePreviousWeek()" style="margin-left: 20px;"></button>
                      <button pButton type="button" label="Current Week" class="btn-primary" (click)="navigateCurrentWeek()" style="margin-left: 20px;"></button>
                      <button pButton type="button" icon="pi pi-angle-right" label="Next Week" class="btn-primary" (click)="navigateNextWeek()" iconPos="right"
                        style="margin-left: 20px;"></button> -->
      </div>
      </div>
      
      <p-table [value]="projects">
        <!-- <ng-template pTemplate="body" let-project let-rowIndex="rowIndex"> -->
        <ng-template pTemplate="header">
          <tr class="header-row">
            <th hidden>ID</th>
            <th style="width:100px">Project</th>
            <th style="width:100px">Task</th>
            <!-- <th style="width:100px" *ngFor="let day of weekDays">{{ day }}</th> -->            
          <th style="width:100px" *ngFor="let day of formattedWeekDaysbillable">{{ day }}</th>
            <th style="width:100px">Total</th>
            <th style="width:100px"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-project let-rowIndex="rowIndex">
          <tr [id]="generateRowId(rowIndex)">
            <td hidden>{{ generateRowId(rowIndex) }}</td>
            <td class="project-cell">
              <input type="text" pInputText [(ngModel)]="project.ProjectID" [hidden]="true" />
              <p-dropdown [(ngModel)]="project.ProjectID" [ngModelOptions]="{ standalone: true }" placeholder="Select Project"
                inputId="txtName" [options]="demoOptions" optionLabel="label" optionValue="value" appendTo="body"
                (onChange)="onProjectChange(project.ProjectID, project)" [style]="{width: '200px'} "
                [panelStyle]="{ 'width': '100%'}" [showClear]="true">
              </p-dropdown>
              <small *ngIf="project.unavailable" class="warning-msg">
                This project is no longer assigned to you.
              </small>
            </td>
            <td>
              <p-dropdown [ngModel]="project.TaskID" (ngModelChange)="project.TaskID = $event ? $event : null"
                [ngModelOptions]="{ standalone: true }" placeholder="Select Task" inputId="txtTask"
                [options]="project.showTaskOptions?project.TaskOptions:[]" optionLabel="label"
                (onChange)="handleTaskChange(project.TaskID, rowIndex, project.IsBillable, project)" optionValue="value"
                appendTo="body" [style]="{width: '200px'}" [panelStyle]="{ 'width': '100%'}" [showClear]="true">
              </p-dropdown>
            </td>
      
            <td *ngFor="let day of weekDays;let i=index" style="width:160px">
              <div class="input-container" [ariaDisabled]="rowDisabledStates[day]">
                <input type="text" pInputText [ngModel]="project.TaskDetails[day]?.Hours"
                (ngModelChange)="onBillableHoursChange($event, day, rowIndex, project)" #inputHour style="width:120px"
                  pattern="[0-9]+(\.[0-9]+)?" inputmode="numeric" maxlength="4"
                  onkeypress="return event.charCode >= 48 && event.charCode <= 57|| event.charCode === 46 "
                  [disabled]="rowDisabledStates[day + '-' + rowIndex]"/>
                <i class="pi pi-book" [ngClass]="{'disabled-icon': rowDisabledStates[day + '-' + rowIndex]}"
                  (click)="!rowDisabledStates[day + '-' + rowIndex] && showDialog(project, day)"></i>
                <i class="pi pi-times" [ngClass]="{'disabled-icon': rowDisabledStates[day + '-' + rowIndex]}"
                  (click)="!rowDisabledStates[day + '-' + rowIndex] && clearValues(project, day)" *ngIf="project.TaskDetails[day]?.Hours !== ''"></i>
              </div>
            </td>
      
            <td>{{ calculateTotalHours(project.TaskDetails) }}</td>
            <td>
              <i class="pi pi-trash" 
              [style.opacity]="!canAddTask ? '0.4' : '1'"
              [style.cursor]="!canAddTask ? 'not-allowed' : 'pointer'"
              (click)="removeProject(rowIndex, project.IsBillable)"></i>
            </td>
          </tr>
          <!-- <div class="card">
                  <p-messages></p-messages>
                </div>
                  -->
        </ng-template>
      
      </p-table>
  </div> 
  
  
  <p-dialog [(visible)]="visible" header="Task Details" [style]="{ width: '25vw' }" [modal]="true">
    <div class="flex py-2 justify-content-center">
      <div class="mb-3">
        <label for="hoursInput" class="form-label">Hours</label>
        <!-- <input pInputText type="text" class="form-control" id="hoursInput" [(ngModel)]="tempHours"> -->
        <input type="text" pInputText class="form-control" [(ngModel)]="tempHours" pattern="[0-9]+(\.[0-9]+)?" inputmode="numeric"
        onkeypress="return event.charCode >= 48 && event.charCode <= 57 || event.charCode === 46" maxlength="4" (change)="onTempHoursChange($event)"/>
      </div>
      <div class="mb-3">
        <label for="CommentInput" class="form-label">Comment</label>
        <textarea rows="4" class="form-control" pInputTextarea id="CommentInput" [(ngModel)]="tempComment" style="resize: none;"
          maxlength="250"></textarea>
      </div>

      <button type="button" class="btn btn-primary" (click)="submitDialog()">Save</button>
    </div>
  </p-dialog>

  <div class="task-container non-billable-tasks">
    <div class="row nonBillRow">
      <div class="col-md-6" style="display: flex;">
        <h4>Non-Billable Tasks</h4>
        <span class="currentweek" >{{ formatDateNew(this.Startweek) }} - {{ formatDateNew(this.Endweek) }}</span>
      </div>
      <div class="col-md-6 d-flex justify-content-end">
        <p-button label="Add Non-Billable Tasks" title="Add Row" [disabled]="!canAddTask" (click)="addNewNonBillProject()"></p-button>
        <!-- <button pButton type="button" icon="pi pi-angle-left" label="Previous Week" class="btn-primary" (click)="navigateNonBillPreviousWeek()" style="margin-left: 20px;"></button>
          <button pButton type="button" class="btn-primary" label="Current Week" (click)="navigateNonBillCurrentWeek()" style="margin-left: 20px;"> </button>
          <button pButton type="button" icon="pi pi-angle-right" label="Next Week" class="btn-primary" (click)="navigateNonBillNextWeek()" iconPos="right"
            style="margin-left: 20px;"></button> -->
      </div>
    </div>
    <p-table [value]="nonBillprojects">
      <ng-template pTemplate="header" >
      <!-- <ng-template pTemplate="body" let-nonBillproject> -->
        <tr class="header-row">
          <th style="width:100px">Task</th>
          <!-- <th *ngFor="let day of nonBillweekDays" style="width:100px">{{ day }}</th> -->
          <th *ngFor="let day of formattedWeekDaysNonbillable" style="width:100px">{{ day }}</th>
          <th style="width:100px">Total</th>
          <th style="width:100px"></th>
        </tr>
        </ng-template>
        <ng-template pTemplate="body" let-nonBillproject let-rowIndex="rowIndex">
          <!-- <tr> -->
          <tr [id]="generateRowId(rowIndex)">
            <td hidden>{{ generateRowId(rowIndex) }}</td>
            <td>
            <p-dropdown [(ngModel)]="nonBillproject.TaskID" [ngModelOptions]="{ standalone: true }" (onChange)="handleTaskChange(nonBillproject.TaskID, rowIndex, nonBillproject.IsBillable, nonBillproject)"
              placeholder="Select Task" inputId="txtTask" [options]="nonbillTasks" optionLabel="Taskname"
              optionValue="TaskId" appendTo="body" [style]="{width: '200px'}" [showClear]="true">
            </p-dropdown>
          </td>
    
          <td *ngFor="let day of nonBillweekDays" style="width:160px">
            <div class="input-container-nonBillable">
              <!-- <input type="text" pInputText [ngModel]="nonBillproject.TaskDetails[day]?.Hours"
                    (ngModelChange)="nonBillproject.TaskDetails[day].Hours = $event" style="width:160px" /> -->
              <input type="text" pInputText [ngModel]="nonBillproject.TaskDetails[day]?.Hours"
              (ngModelChange)="onNonBillableHoursChange($event, day, rowIndex)"
                #nonBillInputHour style="width:140px"
                pattern="[0-9]+(\.[0-9]+)?" inputmode="numeric" maxlength="4"
                onkeypress="return event.charCode >= 48 && event.charCode <= 57 || event.charCode === 46 " />
              <i class="pi pi-book" (click)="showDialog(nonBillproject, day)"></i>
              <i class="pi pi-times" (click)="clearValues(nonBillproject, day)" *ngIf="nonBillproject.TaskDetails[day]?.Hours !== ''"></i>
            </div>
          </td>    
    
          <td>{{ calculateTotalHours(nonBillproject.TaskDetails) }}</td>
          <td>
            <i class="pi pi-trash" 
              [style.opacity]="!canAddTask ? '0.4' : '1'"
              [style.cursor]="!canAddTask ? 'not-allowed' : 'pointer'"
              (click)="removeProject(rowIndex, nonBillproject.IsBillable)"></i>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <p-dialog [(visible)]="nonBillvisible" header="Task Details" [style]="{ width: '25vw' }" [modal]="true">
    <div class="flex py-2 justify-content-center">
      <div class="mb-3">
        <label for="hoursInput" class="form-label">Hours</label>
        <!-- <input type="text" class="form-control" id="hoursInput" [(ngModel)]="tempHours"> -->
        <input type="text" pInputText class="form-control" [(ngModel)]="tempHours" pattern="[0-9]+(\.[0-9]+)?" inputmode="numeric"
          onkeypress="return event.charCode >= 48 && event.charCode <= 57 || event.charCode === 46"  maxlength="4" (change)="onTempHoursChange($event)"/>
      </div>
      <div class="mb-3">
        <label for="CommentInput" class="form-label">Comment</label>
        <textarea rows="4" class="form-control" pInputTextarea id="CommentInput" [(ngModel)]="tempComment" style="resize: none;"
          maxlength="250"></textarea>
      </div>

      <button type="button" class="btn btn-primary" (click)="submitNonBillDialog()">Save</button>
    </div>
  </p-dialog>

  <div class="row submitbtn">
    <div class=" col-md d-flex justify-content-center">
      <button pButton type="button" class="btn btn-primary" icon="pi pi-save" label="Submit" *ngIf="isSubmitEnabled"  [disabled]="!isSubmitEnabled" 
        (click)="saveData()"></button>
    </div>
  </div>
</div>


<p-dialog header="Information" [(visible)]="MessageVisible" [modal]="true" [style]="{width: '20vw'}">
  <p class="Pmessage">
    Timesheet changes saved successfully.
  </p>
</p-dialog>
<p-dialog header="Alert" [(visible)]="alertVisible" [modal]="true" [style]="{width: '20vw'}">
  <p class="Pmessage">
    Please select a Project and a corresponding Task from the dropdowns.
  </p>
</p-dialog>

<p-dialog header="Warning" [(visible)]="warningVisible" [modal]="true" [style]="{width: '35vw'}">
  <p class="Pmessage">
    Total hours should not exceed 40 for billable and non-billable tasks combined.
  </p>
</p-dialog>

<p-dialog header="Alert" [(visible)]="emptyRowWarningVisible" [modal]="true" [style]="{width: '20vw', height:'10vw'}">
  <p class="Pmessage">
    Added new row is mandatory to fill project, task, hours  or please delete the newly added row.
  </p>
</p-dialog>

<p-dialog header="Warning" [(visible)]="hourWarningVisible" [modal]="true" [style]="{width: '20vw'}">
  <p class="Pmessage">
    Entered hours should be greater than 0.
  </p>
</p-dialog>

<p-confirmDialog class="custom-confirmation-dialog"></p-confirmDialog>
<!-- <p-toast position="top-center" key="tc"></p-toast> -->

<app-loader [showLoader]="showLoader"></app-loader>